/**
 * @flow
 * @relayHash 656eb57c4057517b6d38bc78e3babb01
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type pickemInputType = {|
  game_id: string,
  quarter_id: number,
|};
export type guestPickemAnswerInputType = {|
  event_id: string,
  game_id: string,
  quarter_id: string,
  guest_id: string,
|};
export type pickemGameQuestionAnswerInputType = {|
  game_id: string,
  guest_id: string,
  quarter_id: string,
|};
export type PickemWrapperQueryVariables = {|
  arguments?: ?pickemInputType,
  next_arguments?: ?pickemInputType,
  pickemAnswerArgument?: ?guestPickemAnswerInputType,
  args?: ?pickemGameQuestionAnswerInputType,
|};
export type PickemWrapperQueryResponse = {|
  +getGuestGameQuestionAnswerCount: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?{|
      +total_questions: ?number,
      +total_tiebreaker_questions: ?number,
      +total_answered_questions: ?number,
      +total_answered_tiebreaker_questions: ?number,
      +current_chapter_data: ?{|
        +chapter_id: ?number,
        +number_of_questions: ?number,
        +number_of_tiebreaker_questions: ?number,
        +number_of_answered_questions: ?number,
        +number_of_answered_tiebreaker: ?number,
        +number_of_correct_answers: ?number,
      |},
    |},
  |},
  +currentChapter: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?$ReadOnlyArray<?{|
      +_id: ?string,
      +game_id: ?string,
      +quarter_id: ?number,
      +question: ?string,
      +tiebreaker_question: ?boolean,
      +show_tiebreaker_question: ?boolean,
      +options: ?$ReadOnlyArray<?{|
        +_id: ?string,
        +option: ?string,
      |}>,
      +correct_answer: ?string,
    |}>,
  |},
  +nextChapter: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?$ReadOnlyArray<?{|
      +_id: ?string,
      +game_id: ?string,
      +quarter_id: ?number,
      +question: ?string,
      +tiebreaker_question: ?boolean,
      +show_tiebreaker_question: ?boolean,
      +options: ?$ReadOnlyArray<?{|
        +_id: ?string,
        +option: ?string,
      |}>,
    |}>,
  |},
  +getGuestPickemAnswers: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?$ReadOnlyArray<?{|
      +_id: ?string,
      +event_id: ?string,
      +game_id: ?string,
      +guest_id: ?string,
      +question_id: ?string,
      +quarter_id: ?number,
      +is_correct_answer: ?boolean,
      +is_tiebreaker: ?boolean,
      +answer: ?string,
    |}>,
  |},
|};
export type PickemWrapperQuery = {|
  variables: PickemWrapperQueryVariables,
  response: PickemWrapperQueryResponse,
|};
*/


/*
query PickemWrapperQuery(
  $arguments: pickemInputType
  $next_arguments: pickemInputType
  $pickemAnswerArgument: guestPickemAnswerInputType
  $args: pickemGameQuestionAnswerInputType
) {
  getGuestGameQuestionAnswerCount(arguments: $args) {
    code
    message
    data {
      total_questions
      total_tiebreaker_questions
      total_answered_questions
      total_answered_tiebreaker_questions
      current_chapter_data {
        chapter_id
        number_of_questions
        number_of_tiebreaker_questions
        number_of_answered_questions
        number_of_answered_tiebreaker
        number_of_correct_answers
      }
    }
  }
  currentChapter: getPickemQuestionsData(arguments: $arguments) {
    code
    message
    data {
      _id
      game_id
      quarter_id
      question
      tiebreaker_question
      show_tiebreaker_question
      options {
        _id
        option
      }
      correct_answer
    }
  }
  nextChapter: getPickemQuestionsData(arguments: $next_arguments) {
    code
    message
    data {
      _id
      game_id
      quarter_id
      question
      tiebreaker_question
      show_tiebreaker_question
      options {
        _id
        option
      }
    }
  }
  getGuestPickemAnswers(pickemAnswerArgument: $pickemAnswerArgument) {
    code
    message
    data {
      _id
      event_id
      game_id
      guest_id
      question_id
      quarter_id
      is_correct_answer
      is_tiebreaker
      answer
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "arguments",
    "type": "pickemInputType",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "next_arguments",
    "type": "pickemInputType",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "pickemAnswerArgument",
    "type": "guestPickemAnswerInputType",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "args",
    "type": "pickemGameQuestionAnswerInputType",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "message",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "_id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "game_id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quarter_id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "question",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tiebreaker_question",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "show_tiebreaker_question",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "options",
  "storageKey": null,
  "args": null,
  "concreteType": "optionDataType",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "option",
      "args": null,
      "storageKey": null
    }
  ]
},
v10 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "getGuestGameQuestionAnswerCount",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "arguments",
        "variableName": "args"
      }
    ],
    "concreteType": "pickemGameQuestionAnswerType",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "pickemGameQuestionAnswerDataType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_questions",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_tiebreaker_questions",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_answered_questions",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "total_answered_tiebreaker_questions",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "current_chapter_data",
            "storageKey": null,
            "args": null,
            "concreteType": "chapterWiseQuestionAnswerCount",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "chapter_id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_questions",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_tiebreaker_questions",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_answered_questions",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_answered_tiebreaker",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_correct_answers",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": "currentChapter",
    "name": "getPickemQuestionsData",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "arguments",
        "variableName": "arguments"
      }
    ],
    "concreteType": "pickemQuestionType",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "pickemQuestionDataType",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "correct_answer",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": "nextChapter",
    "name": "getPickemQuestionsData",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "arguments",
        "variableName": "next_arguments"
      }
    ],
    "concreteType": "pickemQuestionType",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "pickemQuestionDataType",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ]
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "getGuestPickemAnswers",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "pickemAnswerArgument",
        "variableName": "pickemAnswerArgument"
      }
    ],
    "concreteType": "pickemAnswerType",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "pickemAnswerDataType",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "event_id",
            "args": null,
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "guest_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "question_id",
            "args": null,
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_correct_answer",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_tiebreaker",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "answer",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PickemWrapperQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v10/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PickemWrapperQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v10/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "PickemWrapperQuery",
    "id": null,
    "text": "query PickemWrapperQuery(\n  $arguments: pickemInputType\n  $next_arguments: pickemInputType\n  $pickemAnswerArgument: guestPickemAnswerInputType\n  $args: pickemGameQuestionAnswerInputType\n) {\n  getGuestGameQuestionAnswerCount(arguments: $args) {\n    code\n    message\n    data {\n      total_questions\n      total_tiebreaker_questions\n      total_answered_questions\n      total_answered_tiebreaker_questions\n      current_chapter_data {\n        chapter_id\n        number_of_questions\n        number_of_tiebreaker_questions\n        number_of_answered_questions\n        number_of_answered_tiebreaker\n        number_of_correct_answers\n      }\n    }\n  }\n  currentChapter: getPickemQuestionsData(arguments: $arguments) {\n    code\n    message\n    data {\n      _id\n      game_id\n      quarter_id\n      question\n      tiebreaker_question\n      show_tiebreaker_question\n      options {\n        _id\n        option\n      }\n      correct_answer\n    }\n  }\n  nextChapter: getPickemQuestionsData(arguments: $next_arguments) {\n    code\n    message\n    data {\n      _id\n      game_id\n      quarter_id\n      question\n      tiebreaker_question\n      show_tiebreaker_question\n      options {\n        _id\n        option\n      }\n    }\n  }\n  getGuestPickemAnswers(pickemAnswerArgument: $pickemAnswerArgument) {\n    code\n    message\n    data {\n      _id\n      event_id\n      game_id\n      guest_id\n      question_id\n      quarter_id\n      is_correct_answer\n      is_tiebreaker\n      answer\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5c0d1b12617dfb9191e38b29b1999262';
module.exports = node;
